<div id="overlay">
  <table class="wrapper">
    <tr>
      <td>
        <div id="dummy-overlay" (click)="onCloseClick($event)"></div>
        <div class="lang-popup-container">
          <img
            class="img-bg"
            src="./assets/images/help/fc21/{{ data.currentLanguage }}/{{
              data.currentLanguage
            }}_Tutorial_Background@2x.webp"
          />
          <img
            class="img-content"
            src="./assets/images/help/fc21/{{ data.currentLanguage }}/{{
              data.currentLanguage
            }}_Languages@2x.webp"
          />
          <img
            class="closeiconImg"
            [appImageSprite]="'close'"
            [params]="menu_icons"
            (click)="onCloseClick($event)"
          />
        </div>
      </td>
    </tr>
  </table>
</div>
